import { render } from "./ApproveMail.vue?vue&type=template&id=6b5ea428"
import script from "./ApproveMail.vue?vue&type=script&lang=js"
export * from "./ApproveMail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__